import Axios from 'axios';
import { getSignedQuery } from './md5sign';
import { hideLoading, showLoading } from './loading';
import { getOssToken } from '../pages/order/api';
import { message } from 'antd';
import OSS from 'ali-oss';
import md5 from 'js-md5';
import SparkMD5 from 'spark-md5';

export function guid() {
  try {
    return crypto?.randomUUID?.();
  } catch (error) {
    const blobUrl = URL.createObjectURL(new Blob());
    URL.revokeObjectURL(blobUrl);
    return blobUrl.slice(blobUrl.lastIndexOf('/') + 1);
  }
}

export function dateFormat(date, fmt = 'yyyy-MM-dd') {
  var o = {
    "y+": date.getFullYear(),  // 年份
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}

export function amountToString(amount, num = 2) {
  if (typeof (amount) !== "number") {
    amount = Number(amount);
  }

  if (amount.toString().indexOf('.') !== -1) {
    amount = amount.toFixed(num);
  }
  if (num === 4) {
    amount = +amount;
  }

  let amountStr = '';
  amount = amount.toString();

  let count = 0;
  let index = amount.indexOf('.');
  if (index === -1) {
    for (let i = amount.length - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        amountStr = amount.charAt(i) + ',' + amountStr;
      } else {
        amountStr = amount.charAt(i) + amountStr;
      }
      count++;
    }
    if (num === 2) {
      amountStr += '.00';
    }
  } else {
    amountStr = amount.substring(index);
    for (let i = amount.indexOf('.') - 1; i >= 0; i--) {
      if (count % 3 === 0 && count !== 0) {
        amountStr = amount.charAt(i) + ',' + amountStr;
      } else {
        amountStr = amount.charAt(i) + amountStr;
      }
      count++;
    }
  }
  return amountStr;
}

export function amountStrToNumber(amountStr) {
  if (!amountStr || amountStr.length <= 0) { return 0; }
  let result = amountStr.replace(new RegExp(',', 'g'), '');
  let amount = Number(result);
  if (isNaN(amount)) {
    amount = 0;
  }
  return amount;
}

export function keyToValue(values) {
  return Reflect.ownKeys(values).reduce((pre, next) => ({ ...pre, [values[next]]: next }), {});
}

export function deepClone(obj, hash = new WeakMap()) {
  //先把特殊情况全部过滤掉 null undefined date reg
  if (obj == null) return obj; //null 和 undefined 都不用处理
  if (obj instanceof Date) return new Date(obj);
  if (obj instanceof RegExp) return new RegExp(obj);
  if (typeof obj !== 'object') return obj; // 普通常量直接返回

  //  防止对象中的循环引用爆栈，把拷贝过的对象直接返还即可
  if (hash.has(obj)) return hash.get(obj);

  // 不直接创建空对象的目的：克隆的结果和之前保持相同的所属类
  // 同时也兼容了数组的情况
  let newObj = new obj.constructor();

  hash.set(obj, newObj); // 制作一个映射表

  //判断是否有 key 为 symbol 的属性
  let symKeys = Object.getOwnPropertySymbols(obj);
  if (symKeys.length) {
    symKeys.forEach(symKey => {
      newObj[symKey] = deepClone(obj[symKey], hash);
    });
  }
  if (Object.prototype.toString.call(obj) === '[object Map]') {
    obj.forEach((v, k) => {
      deepClone(obj[k], hash);
      newObj.set(k, v);
    });
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) { // 不拷贝原型链上的属性
      newObj[key] = deepClone(obj[key], hash); // 递归赋值
    }
  }
  return newObj;
}

export const formatAddressItem = (item = {}) => ({ ...item, address_id: item.id, contacts_name: item.username, contacts_phone: item.phone, format_address: `${item?.province_name}${item?.city_name}${item?.area_name}${item?.address}` });
export const formatAddressList = (list = []) => list.map(item => ({ ...formatAddressItem(item) }));

function downloadBlob(blob, name) {
  const url = window.URL.createObjectURL(blob);
  const elementA = document.createElement('a');
  elementA.href = url;
  elementA.download = name;
  elementA.click();
  window.URL.revokeObjectURL(url);
}

export async function downLoad({ url, name }) {
  showLoading();
  fetch(getSignedQuery({ baseUrl: url })).then(res => res.blob().then(blob => {
    downloadBlob(blob, name);
    hideLoading();
  }));
}

export const formateTree = (data = [], companyId) => {
  return data.map(item => {
    const { company_name, company_id, children } = item;
    const tree = formateTree(children);
    return { title: company_name, value: company_id, key: company_id, children: tree, self: '11', disabled: +company_id === +companyId };
  });
};

export function treeToArray(data = []) {
  return data.reduce((res, item) => {
    const { children, ...i } = item;
    return res.concat(i, children?.length ? treeToArray(children) : []);
  }, []);
}

export const createPDF = async (data = {}) => {
  showLoading();
  const res = await Axios({
    url: 'https://tool-html2any.cpgroupcloud.com/html2any/generatePDF',
    method: 'POST',
    data: {
      width: 1240,
      height: 1754,
      ...data
    },
    responseType: 'blob'
  });
  downloadBlob(res.data, data.fileName);
  hideLoading();
};


export async function ossToken() {
    const { data: { code, msg, data } } = await getOssToken();
    return new Promise(resolve => {
      if (+code === 0) {
        return resolve(data);
      } else {
        message.error(msg);
      }
    });
  }

  function getFileMd5BySlice(file, random) {
  return new Promise((resolve) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice, chunkSize = 1024 * 1024, chunks = Math.ceil(file.size / chunkSize), spark = new SparkMD5.ArrayBuffer(), fileReader = new FileReader();
    let currentChunk = 0;
    fileReader.onload = function (e) {
      spark.append(e.target.result);
      currentChunk++;
      currentChunk < chunks ? loadNext() : resolve(random ? md5(`${spark.end()}${guid()}`) : spark.end());
    };

    fileReader.onerror = function () {
      resolve(`${md5(file + guid(), chunkSize)}`);
    };
    function loadNext() {
      const start = currentChunk * chunkSize, end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }

    loadNext();
  });
};

  export const uploadBase = (currentFile, random = true) => {
  showLoading();
  return new Promise(async resolve => {
    try {
      const { SecurityToken, AccessKeyId, AccessKeySecret } = await ossToken();
      const client = new OSS({ region: 'oss-cn-beijing', accessKeyId: AccessKeyId, accessKeySecret: AccessKeySecret, stsToken: SecurityToken, refreshSTSTokenInterval: 300000, bucket: 'cp-cpmart-dev' });
      const { file, file: { name } } = currentFile;
      const ext = name.substring(name.lastIndexOf('.'));
      const fileMd5 = `${await getFileMd5BySlice(file, random)}${ext}`;
      let { url } = await client.put(fileMd5, file);
      url = url.replace('http:', 'https:');
      resolve({ uid: guid(), name, status: 'done', url, thumbUrl: url, url_name: name, md5Name: `${fileMd5}`, img_url: url });
    } catch (error) {
      message.open({ type: 'error', content: '上传失败，请重新上传', });
    } finally {
      hideLoading();
    }
  });
};

export function getAllParams(url = window.location.search) {
  return Object.fromEntries((new URLSearchParams(url)).entries());
}